module.exports = __webpack_public_path__ + "static/media/home_slide_next.020f8ec0.svg";